import React from 'react';
import classNames from 'classnames';

import {useTheme, useLegalInfo, useI18n} from 'pageflow-scrolled/frontend';

import {Logo} from './Logo';

import styles from './LinkListFooter.module.css';

export function LinkListFooter() {
  const theme = useTheme();
  const legalInfo = useLegalInfo();
  const {t} = useI18n();
  const items = theme.options.footerLinks || [];

  if (!items.length) {
    return null;
  }

  function renderLinkOrButton(item) {
    if (item.kind === 'privacySettings') {
      return (
        <button className={styles.link}
                onClick={() => window.pageflowDisplayPrivacySettings() &&
                             window.pageflowDisplayPrivacySettings()}>
          {t('pageflow_scrolled.public.privacy_settings')}
        </button>
      );
    }

    if (legalInfo[item.kind]) {
      item = legalInfo[item.kind];
    }

    return (
      <a className={styles.link}
         href={item.url}
         dangerouslySetInnerHTML={{__html: item.label}} />
    );
  }
  return (
    <div className={classNames(styles.bar,
                               styles[`layout-${theme.options.linkListFooterLayout || 'logoAbove'}`])}>
      <Logo />

      <div className={styles.content}>
        <ul className={styles.items}>
          {items.filter(item => !item.hidden).map((item, index) =>
            <li key={index} className={styles.item}>
              {renderLinkOrButton(item)}
            </li>
          )}
        </ul>

        <p className={styles.text}
           dangerouslySetInnerHTML={{__html: theme.options.footerText}} />
      </div>
    </div>
  );
}
